import React from 'react';
import cn from '../../lib/cn';

const base =
  'group relative inline-flex items-center justify-center gap-2.5 whitespace-nowrap ' +
  'font-sans text-[0.8rem] uppercase tracking-widest transition-all duration-300 ease-silk ' +
  'disabled:pointer-events-none disabled:opacity-50';

const variants = {
  // Sunrise gradient lifted straight from the logo mark.
  solid:
    'bg-sunrise text-ink-950 font-medium shadow-[0_10px_30px_-12px_rgba(244,145,0,0.65)] ' +
    'hover:shadow-[0_16px_40px_-12px_rgba(244,145,0,0.8)] hover:-translate-y-0.5',
  ink: 'bg-ink-900 text-canvas hover:bg-ink-800 hover:-translate-y-0.5',
  outline:
    'border border-ink-900/25 text-ink-900 hover:border-ink-900/60 hover:bg-ink-900 hover:text-canvas',
  gold:
    'border border-champagne-300/60 text-champagne-200 hover:bg-champagne-300 hover:text-ink-950',
  ghost: 'text-ink-700 hover:text-ink-950',
};

const sizes = {
  sm: 'h-10 px-5',
  md: 'h-12 px-7',
  lg: 'h-14 px-9 text-[0.85rem]',
};

/**
 * The site's only button. Renders an <a> when `href` is passed, otherwise a
 * <button>, so links stay links for keyboard and assistive tech.
 */
export function Button({
  as,
  href,
  variant = 'solid',
  size = 'md',
  className,
  children,
  ...rest
}) {
  const Tag = as || (href ? 'a' : 'button');
  const linkProps =
    Tag === 'a' && /^https?:/.test(href || '')
      ? { target: '_blank', rel: 'noreferrer noopener' }
      : {};

  return (
    <Tag
      href={href}
      className={cn(base, variants[variant], sizes[size], className)}
      {...linkProps}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default Button;
